import Button from 'components/Button';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import mp from 'assets/images/logo-mp.svg';
import stripe from 'assets/images/logo-stripe.svg';
import { format } from 'utils/helpers';

export default function UpdateSubscription({ plan: originalPlan, account: originalAccount, handleCancel, isLoading }) {
  const { t } = useTranslation();
  const [desc, setDesc] = useState()

  const plan = originalPlan;
  const account = originalAccount;

  // Función para formatear precios con coma decimal y punto para miles
  const formatPrice = (price) => {
    return price.toLocaleString('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  useEffect(()=>{
    if(plan && account){
      setDesc(plan?.name.split(' ').pop())
    }
  },[plan,account])

  return (
    <>
      {plan && (
        <>
          <div className='flex flex-col gap-3 max-w-[480px] w-full mb-6'>
            <div className='flex'>
              <div className='font-bold grow'>Plan</div>
            </div>
            <div className='bg-neutral-black p-6 rounded-2xl'>
              <div className='text-lg font-semibold'>Plan Pro</div>
              <div className='flex items-baseline gap-1'>
                <span className='font-thunder text-2xl uppercase'>ARS</span>
                <span className='font-thunder text-4xl'>
                  {formatPrice(Number(plan.pricing_data.price))}
                </span>
                <span className='text-neutral-silver-200'>/ {t('global.month')}</span>
              </div>
            </div>
          </div>
          <div className='w-full max-w-[480px] flex flex-col gap-3'>
            <span className='font-bold'>{t('account.payment_method')}</span>
            <div className='bg-neutral-black rounded-2xl px-6 py-4'>
              <div className='flex flex-row items-center'>
                <div className='flex flex-col grow'>
                  <span className='text-lg'>{t('account.credit_debit')}</span>
                  <span className='text-sm text-neutral-silver-300'>
                    {t('account.payment_detail')} Mercado Pago
                  </span>
                </div>
                <div>
                  <img 
                    src={mp}
                    alt="Mercado Pago"
                    width={104} 
                    height={36} />
                </div>
              </div>
              <div className='mt-4'>
                <ul className='list-disc list-inside text-sm text-neutral-silver-200'>
                  <li>{t('account.start_billing')} {format.dateDdMmYyyy(account.subscription.date_started)}</li>
                  {account.subscription.trial_ends_at && (
                    <li>{t('account.free_date')} {format.dateDdMmYyyy(account.subscription.trial_ends_at)}</li>
                  )}
                  <li>{t('account.cancel_anytime')}</li>
                </ul>
              </div>
            </div>
            <div className='flex justify-center w-full'>
              <Button
                customStyle='!text-error-red !px-4 !py-2 !w-[210px] !text-base !font-normal hover:!bg-neutral-black/50'
                type='submit'
                style='tertiary'
                loading={isLoading}
                disabled={isLoading}
                text={t('account.cancel_subscription')}
                onClick={handleCancel} />
            </div>
          </div>
        </>
      )}
    </>
  );
}